import { defineStyleConfig } from '@chakra-ui/styled-system';

const FormLabelTheme = defineStyleConfig({
  baseStyle: {
    fontSize: 'sm',
    marginBottom: '2px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  sizes: {},
  variants: {
    floating: {
      position: 'absolute',
      top: '-6px',
      bg: 'white',
      zIndex: 10,
      left: '12px',
      px: '6px',
      fontSize: '9px',
    },
    normal: {},
  },
  defaultProps: {
    variant: 'floating',
  },
});

export default FormLabelTheme;
